import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const BookmarkFilled = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="filled bookmark icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M3 21.9808V2C3 0.895431 3.89543 0 5 0H19C20.1046 0 21 0.895431 21 2V21.9808C21 23.7888 18.7915 24.6688 17.5481 23.3563L12 17.5L6.45191 23.3563C5.20847 24.6688 3 23.7888 3 21.9808Z"
    />
  </svg>
)
